"use client";

import { useStore } from "@nanostores/react";
import OpteraSpinner from "common/components/OpteraSpinner";
import { user } from "common/stores/UserStore";
import { Endorsement } from "common/utils/UserUtils";
import { useRouter } from "next/navigation";
import { useEffect, useMemo } from "react";
import {
	getPersistentClaritySessionId,
	getLocalPartEmail,
} from "common/utils/auth/AuthUtils";
import { isOpteraAdmin } from "common/stores/UserStore";

export default function OpteraHome() {
	const $user = useStore(user);
	const router = useRouter();

	// Determine destination in a single, clear place
	const bounceTo = useMemo(() => {
		if (!$user || $user.username === "loading" || $user.organization_id === 0) {
			return "";
		}

		const { endorsements, traits, roles } = $user;
		const has = (key: Endorsement) => endorsements.includes(key);

		if (typeof window !== "undefined" && window.clarity) {
			const sessionId = getPersistentClaritySessionId();
			const isAdmin = isOpteraAdmin();
			window.clarity("set", "sessionId", sessionId);
			window.clarity(
				"identify",
				$user.username,
				sessionId,
				window.location.pathname,
				getLocalPartEmail($user.username)
			);
			window.clarity("set", "organization", $user.organization);
			window.clarity("set", "user_role", isAdmin ? "optera:admin" : "client");
		}

		if (has("operator:brand")) {
			return "/operator/emissions-analysis";
		}
		if (has("supply_chain_insights:brand")) {
			return "/supplyChainManager";
		}
		if (has("survey:surveyee") || has("survey:surveyor")) {
			const isSurveyee = Object.keys(traits || {}).includes("survey:surveyee");
			const isSurveyor =
				has("survey:surveyor") || roles.includes("survey:surveyor");

			if (isSurveyor && !isSurveyee) {
				return "/survey/survey-dashboard";
			}
			return "/survey/campaign-select";
		}
		if (
			has("sam:brand") ||
			has("supplychain:brand") ||
			has("supplychain:supplier")
		) {
			return "/legacyOverview";
		}

		console.warn("No access to any known features, staying on home page");
		return "";
	}, [$user]);

	// Prefetch and redirect instantly
	useEffect(() => {
		if (!bounceTo) return;
		router.prefetch(bounceTo);
		router.replace(bounceTo);
	}, [bounceTo, router]);

	return (
		<div className="pt-3 mt-2 ta-c">
			<OpteraSpinner />
		</div>
	);
}
